<template>
  <div class="modal-window" :class="modalInfo.name == 'infoShareModal' ? 'bds048' : 'bds048 bds049'">
    <header class="modal-header">
        <div class="tit">{{modalInfo.title}}</div>
        <button @click="closeModal()" class="btn_close">닫기</button>
    </header>

    <div class="modal-content">
      <div class="info-txt" v-if="modalInfo.name == 'infoShareModal'">{{ $i18nUtil.trans("message.ReqPostModal.shar.001","정보공유에 게시를 위해 카테고리 위치를 선택해주세요.") }}</div>
      <div class="info-txt" v-else>{{ $i18nUtil.trans("message.ReqPostModal.cfrc.001","회의/협의 게시를 위해 카테고리 위치를 선택해주세요.") }}</div>
      <div class="top" v-if="modalInfo.name != 'infoShareModal'">
        <dl class="dl_layer">
          <dt><button type="button" class="btn_link_add" @click="$event.target.parentElement.classList.toggle('active');">{{ $i18nUtil.trans("title.RegistCategoryModal.003","카테고리 추가") }}</button></dt>
            <dd>
              <div class="input-box">
                <input type="text" required :placeholder="$i18nUtil.trans('UB015')" v-model="addCategoryName"  @input="displayBytes(maxBytes, addCategoryName, $event)">
                <div class="error" v-if="error">{{ $i18nUtil.trans("message.ReqPostModal.001","입력 가능한 글자수를 초과하였습니다.") }} <span>({{checkBytes + `/` + maxBytes + `bytes`}})</span></div>
                <div class="error" v-if="errorCategoryName">{{$i18nUtil.trans('UB015')}}</div>
                <!-- <button type="button" class="input-txt-del" @click="addCategoryName =''">입력 삭제</button> -->
              </div>
              <button type="button" class="btn-primary-small black" @click="insertCategory">{{ $i18nUtil.trans("button.register","등록") }}</button>
            </dd>
          </dl>
      </div>

      <div class="btm">
        <div :class="modalInfo.name == 'infoShareModal' ? 'dropdown ty2 wide relative only' : 'dropdown ty2 wide relative'">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" :class="selectedCategoryName == '' ? 'disabled' : 'ell-singleline'">
                {{selectedCategoryName == '' 
                  ? (modalInfo.name == 'infoShareModal' ? $i18nUtil.trans("message.ReqPostModal.shar.002","정보공유 카테고리 선택") : $i18nUtil.trans("message.ReqPostModal.cfrc.002","회의/협의 카테고리 선택") ) 
                  : selectedCategoryName
                }}
              </v-btn>
            </template>
            <div class="dropdown-list">
              <div class="scroll">
                <div class="dropdown-list-item" v-if="shareCategoryList == null || shareCategoryList.length == 0">
                  <div class="tit">
                    <button type="button">
                      {{ $i18nUtil.trans("message.ReqPostMddal.002","선택 가능한 카테고리가 없습니다. 카테고리를 추가해주세요.") }}
                    </button>
                  </div>
                </div>
                <div class="dropdown-list-item" 
                  v-else 
                  v-for="(shareCategoryItem, shareCategoryIndex) in shareCategoryList"
                  :key="shareCategoryIndex" 
                  :class="selectedCategoryMid == shareCategoryItem.categoryMid ? 'active' : ''"
                  @click="changeCategoryItem(shareCategoryItem)"
                >
                  <div class="tit">
                    <button type="button" class="ell-singleline">
                      {{shareCategoryItem.categoryName}}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </v-menu>
        </div>
        <!-- <dl class="dl_layer select_ty3 scroll full">
          <dt id="dtCategoryItem">
            <button type="button" @click="$event.target.parentElement.classList.toggle('active');">
              {{selectedCategoryName == '' 
                ? (modalInfo.name == 'infoShareModal' ? '정보공유 카테고리 선택' : '회의/협의 카테고리 선택') 
                : selectedCategoryName
              }} 
            </button>
          </dt>
          <dd style="width:100%">
            <ul>
              <li v-if="shareCategoryList == null || shareCategoryList.length == 0">
                <button type="button">
                선택 가능한 카테고리가 없습니다. 카테고리를 추가해주세요.
                </button>
              </li>
              <li v-else
                v-for="(shareCategoryItem, shareCategoryIndex) in shareCategoryList"
                :key="shareCategoryIndex"
                :class="selectedCategoryMid == shareCategoryItem.categoryMid ? 'active' : ''"
                @click="changeCategoryItem(shareCategoryItem, 'dtCategoryItem')"
              >
                <button type="button">
                  {{shareCategoryItem.categoryName}}
                </button>
              </li>
            </ul>
          </dd>
        </dl> -->
        <div class="error" v-if="errorSelected">{{$i18nUtil.trans('UB007')}}</div>
      </div>
    </div>

    <footer class="modal-footer">
      <button type="button" class="btn_ty1" @click="onClickSubmit">{{ $i18nUtil.trans("button.post","게시") }}</button>
    </footer>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import axios from "axios";

export default {
  props: {
    modalInfo: {
      type: Object,
      required: true,
    },
  },
  components: {
  },
  data() {
    return {
      categoryItem:null,
      selectedCategoryMid : null,
      selectedCategoryName : '',
      paperId: this.$props.modalInfo.paperId,
      shareCategoryList : [],
      toastInfo: {
        obj: this.$toasted,
          message: "",
          options: {
            theme: "toasted-primary",
          position: "bottom-left",
          duration: 3000,
          },
      },
      addCategoryName:"",
       
      error : false, 
      checkBytes : 0,
      maxBytes : 24, 
      errorCategoryName : false,
      errorSelected:false,
    };
  },
  mounted() {
    // console.log(this.modalInfo);
    if(this.modalInfo.name == "infoShareModal"){
        this.initShareCategoryList();
    }else{
        this.initCooperationCategoryList();
    }
  },
  watch: {
  },
  beforeDestroy() {
  },
  methods: {
    ...mapActions("restAction", ["COWORK_REST_SIMPLE_ACTION"]),
    ...mapActions("modals", ["showToast"]),
    /* 정보공유 카테고리 리스트 조회 */
    initShareCategoryList() {
        let obj = this;
        let reqData = {};
        reqData.req = obj.req;
        // 공개 + 멤버인 카테고리 리스트 
        reqData.url = "/api/copaper/infoshare/getShareCategoryListNormalAndRestrict";
        reqData.method = "post";
        reqData.params = {
            parentCategoryMid : "",
        };
        obj.showLoadingbar();
        obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then(function (res) { 
            obj.hideLoadingbar();
            obj.shareCategoryList = res.result.categoryList;
            // obj.selectedCategoryMid = obj.shareCategoryList[0].categoryMid;
            // obj.categoryItem=res.result[0];
        })
        .catch(function (err) {
            obj.hideLoadingbar();
            console.log(err);
        });
    },
    initCooperationCategoryList(){
        let obj = this;
        let reqData = {};
        reqData.req = obj.req;
        // 카테고리 멤버인 카테고리 리스트
        reqData.url = "/api/copaper/cooperation/getCfrcCategoryListInCategoryMember";
        reqData.method = "post";
        reqData.params = {
        };
        obj.showLoadingbar();
        obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then(function (res) { 
            obj.hideLoadingbar();
            if(res.result.categoryList.length != 0){
                obj.shareCategoryList = res.result.categoryList;
            }
        })
        .catch(function (err) {
            obj.hideLoadingbar();
            console.log(err);
        });
    },
    /* 카테고리 변경 이벤트 */
    changeCategoryItem(shareCategoryItem) {
      let obj = this;
      obj.categoryItem = shareCategoryItem;
      obj.selectedCategoryMid = shareCategoryItem.categoryMid;
      obj.selectedCategoryName = shareCategoryItem.categoryName; 
      obj.errorSelected = false;
    },

    /* 게시요청 */
    onClickSubmit() { 
      if(this.selectedCategoryMid === null) {
          this.errorSelected = true;
          return;
      }
      this.showLoadingbar();
      if(this.modalInfo.name == "infoShareModal"){
          let obj = this;
          let reqData = {};
          reqData.req = obj.req;
          reqData.url = "/api/copaper/paper/copyPaper2InfoSearch";
          reqData.method = "post";
          reqData.params = {
            siteId: this.categoryItem.sharePointSiteId, // root 밑 문서라이브러리아이디 
            folderId: this.categoryItem.sharePoinFolderId,//
            paperId: this.paperId,
            categoryMid:this.categoryItem.categoryMid, 
            type: "SHAR",
          };
          obj
          .COWORK_REST_SIMPLE_ACTION(reqData)
          .then(function (res) {
              obj.hideLoadingbar();
              if(res.errorCode) {
                alert(res.errorCode);
              }
              // (obj.modalInfo.name == 'infoShareModal' ? '정보공유' : '회의/협의' ) + "에 게시되었습니다."
              obj.toastInfo.message =  obj.$i18nUtil.trans('TB014');
              obj.showToast(obj.toastInfo);
              obj.$emit("close");
          })
          .catch(function (err) {
              obj.hideLoadingbar();
              console.log(err);
          });
      }else if(this.modalInfo.name == "cooperationModal"){
          let obj = this;
          let reqData = {};
          reqData.req = obj.req;
          //reqData.url = "/api/copaper/cooperation/insertCfrcFolder";
          reqData.url = "/api/copaper/paper/copyPaper2InfoSearch";
          reqData.method = "post";
          reqData.params = {
            siteId: this.categoryItem.sharePointSiteId, // root 밑 문서라이브러리아이디 
            folderId: this.categoryItem.sharePoinFolderId,//
            paperId: this.paperId, 
            categoryMid:this.categoryItem.categoryMid,
            type: "CFRC",
          };
          obj
          .COWORK_REST_SIMPLE_ACTION(reqData)
          .then(function (res) {
              obj.hideLoadingbar();
              obj.toastInfo.message = obj.$i18nUtil.trans('TB018');
              obj.showToast(obj.toastInfo);
              obj.$emit("close");
          })
          .catch(function (err) {
              obj.hideLoadingbar();
              console.log(err);
          }); 
      }
        
    },
    insertCategory(){
      // console.log(this.addCategoryName);
      if(this.addCategoryName.length == 0 ){
        this.errorCategoryName = true;
        return;
      }
      
      if(this.error){
        return;
      }

      let url="";
      if(this.modalInfo.name == "infoShareModal"){
          url="/api/copaper/infoshare/insertShareCategory"; 
      }else{
          url="/api/copaper/cooperation/insertCfrcCategory";
      }
      let obj = this;
      let reqData = {};
      reqData.params ={
          categoryName: this.addCategoryName
      }
      reqData.req = obj.req;
      reqData.url = url;
      reqData.method = "post";
      obj.showLoadingbar();
      obj
          .COWORK_REST_SIMPLE_ACTION(reqData)
          .then(res => { 
            obj.hideLoadingbar();
            obj.toastInfo.message = obj.$i18nUtil.trans('TB076');
            obj.showToast(obj.toastInfo);
            if(this.modalInfo.name == "infoShareModal"){
                //console.log(res);
                //console.log("정보공유 카테고리 추가 완료 ");
                this.initShareCategoryList();
                this.addCategoryName="";
            }else{
                //console.log(res);
                //console.log("회의/협의체 카테고리 추가 완료 ");
                this.initCooperationCategoryList();
                this.addCategoryName="";
            }
          })
          .catch(function(err) {
            obj.hideLoadingbar();
            console.log(err);
          });
    },
    closeModal(){
      let obj = this;
      obj.toastInfo.message = obj.$i18nUtil.trans("message.ReqPostMddal.003","게시요청 취소하였습니다.");
      obj.showToast(obj.toastInfo);
      obj.$emit('close');
    },
    /* byte 체크 */
    displayBytes(byteLength, categoryName, _event) {
      let obj = this;
      categoryName = _event.target.value;
      obj.addCategoryName = categoryName;
      let checkBytes = obj.getByteLength(obj.addCategoryName);
      obj.checkBytes = checkBytes;
      obj.error = false;
      if(checkBytes > byteLength) {
        obj.error = true;
      }
      if(checkBytes > 0) {
        obj.errorCategoryName = false;
      }
    },
    getByteLength(str) {
      if (str == null || str.length == 0) {
        return 0;
      }
      var size = 0;
      for ( var i = 0; i < str.length; i++) {
        size += this.charByteSize(str.charAt(i));
      }
      return size;
    },
    cutByteLength(data, len) {
      if (s == null || s.length == 0) {
        return 0;
      }
      var size = 0;
      var rIndex = s.length;
      for ( var i = 0; i < s.length; i++) {
        size += this.charByteSize(s.charAt(i));
        if( size == len ) {
            rIndex = i + 1;
            break;
        } else if( size > len ) {
            rIndex = i;
            break;
        }
      }
      return s.substring(0, rIndex);
    },
    charByteSize(ch) {
      if (ch == null || ch.length == 0) {
        return 0;
      }
      var charCode = ch.charCodeAt(0);

      if (charCode <= 0x00007F) {
        return 1;
      } else if (charCode <= 0x0007FF) {
        return 2;
      } else if (charCode <= 0x00FFFF) {
        return 2;
      } else {
        return 2;
      }
    },
  },
};
</script>

<style scoped>
.modal-content {
  height: auto;
}

/* .header {
  padding: 1em;
}
.header .close-icon {
  float: right;
  cursor: pointer;
}
.content {
  padding: 0 1.5em;
}

.footer {
  float: center;
  padding: 1em;
  margin-top: 15px;
} */
</style>



// WEBPACK FOOTER //
// src/components/cowork/general/project/modal/ReqPostModal.vue